import { ApiBaseClass, OurUseQueryOptions } from "@nens/react-query-utils";
import { objectEntries, objectFromEntries } from "@nens/shared-utils";

import {
  DefaultApi,
  ProjectsApi,
  SchemaApi,
  SendLoginLinkApi,
  StatusApi,
  UsersApi,
} from "@/api/apis/index";

import { BASE_PATH, Configuration } from "./runtime";

const apis = {
  DefaultApi,
  ProjectsApi,
  SchemaApi,
  SendLoginLinkApi,
  StatusApi,
  UsersApi,
} as const;

// Store for the tenant ID and AuthToken
let accessToken: string | null = null;

const setAccessToken = (token: string) => {
  accessToken = token;
};

const getQueryOptions = <T>(queryOptions: OurUseQueryOptions<T>): OurUseQueryOptions<T> => {
  const key = queryOptions.queryKey ?? [];

  return {
    ...queryOptions,
    queryKey: ["tbi-api", ...key],
  };
};

type ApiInstances = {
  [K in keyof typeof apis]: InstanceType<(typeof apis)[K]>;
};

/* From Django docs, TS-ified a bit */
function getCookie(name: string) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export const getCsrfToken = () => getCookie("csrftoken");

// Use the updated wrapApiWithTenantId to create instances and inject tenantId
const getTbiApi = () => {
  const apiInstances = objectFromEntries(
    objectEntries(apis).map(([key, ApiClass]) => {
      const configuration = new Configuration({
        accessToken: accessToken + "",
        credentials: "same-origin" /* For CSRF cookie */,
        headers: { "X-CSRFToken": getCsrfToken() ?? "" },
      });
      const apiInstance = new ApiClass(configuration);

      return [key, apiInstance];
    })
  ) as ApiInstances;

  return {
    ...apiInstances,
    BaseApi: new ApiBaseClass(BASE_PATH, undefined, accessToken + ""),
    accessToken,
    setAccessToken,
    getQueryOptions,
  };
};

export default getTbiApi;
